'use es6';

import { combineReducers } from 'redux';
import codeAccordion from './CodeAccordion';
export default combineReducers({
  codeAccordion
});